'use client';

import { motion, useAnimation } from 'framer-motion';
import Image from 'next/image';

export default function BouncyDoughnutsLogo({ className = '' }: { className?: string }) {
  const controls = useAnimation();
  const handleClick = () => {
    controls.start({
      scale: [1.2, 1],
      rotate: [10, 0],
      skewX: [-15, 0],
      transition: {
        duration: 1.3,
        type: 'spring',
        damping: 4,
        stiffness: 120,
      },
    });
  };

  return (
    <motion.div className={ className } animate={ controls } onClick={ () => handleClick() }>
      <Image src={ '/logos/logo-with-doughnuts.webp' }
             alt={ 'Logo s donuty' }
             width={ 1024 }
             height={ 1024 }
             className={ 'w-full h-auto' }
             priority
             loading={ 'eager' }
             sizes={ '(max-width: 768px) 90vw, 25vw' } />
    </motion.div>
  );
}
